import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  addIncomeSource() {
    this.element.append(this.addIncomeSourceElement)
    this.element.requestSubmit();
  }

  get addIncomeSourceElement() {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = 'add_income_source'
    input.value = true

    return input
  }
}
